import { useEffect } from 'react'

import { useTasksStore } from '../stores/tasks'

export const useProjectTasks = () => useTasksStore((state) => state.tasks)

export const useLoadingProjectTasks = () =>
  useTasksStore((state) => state.loadingTasks)

export const useToggleProjectTask = () =>
  useTasksStore((state) => state.mutations.toggleTask)

export const useFetchProjectTasks = (slug: string) => {
  const { fetchTasks } = useTasksStore((state) => state.loaders)
  const { reset } = useTasksStore((state) => state.actions)

  useEffect(() => {
    fetchTasks(slug)
    return reset
  }, [slug])
}
